import { Reducer } from 'redux';
import {
  IGeneralStatsAction,
  IPlaceStatsAction,
  STATS_ERROR,
  STATS_GENERAL_REQUEST,
  STATS_GENERAL_SUCCESS,
  STATS_PLACES_REQUEST,
  STATS_PLACES_SUCCESS,
} from '../actions/stats';
import { IStatsState } from '../types/stats';

export const initialState: IStatsState = { loading: false };

const reducer: Reducer<IStatsState> = (
  state: IStatsState = initialState,
  action: IGeneralStatsAction | IPlaceStatsAction
) => {
  switch (action.type) {
    case STATS_GENERAL_REQUEST:
      return { loading: true };
    case STATS_GENERAL_SUCCESS:
      return { general: action.payload.rows, loading: false };
    case STATS_PLACES_REQUEST:
      return { loading: true };
    case STATS_PLACES_SUCCESS:
      return { places: action.payload.rows, loading: false };
    case STATS_ERROR:
      return { error: action.message, loading: false };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/stats.ts